import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Table, Alert } from 'react-bootstrap';
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import api from '../services/api';

export default function InventoryPage({ setPage }) {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({
    productId: '',
    storeId: '',
    quantity: '',
    currentPrice: '',
    supplierLeadTime: '',
    reorderPoint: '',
    orderFulfillmentTime: '',
    expiryDate: ''
  });
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/inventory')
      .then(res => setItems(res.data))
      .catch(err => setError(err.message));
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAdd = async () => {
    try {
      const { data } = await api.post('/inventory', {
        ...form,
        quantity: Number(form.quantity)
      });
      setItems([...items, data]);
      setForm({
        productId: '',
        storeId: '',
        quantity: '',
        currentPrice: '',
        supplierLeadTime: '',
        reorderPoint: '',
        orderFulfillmentTime: '',
        expiryDate: ''
      });
      setError('');
    } catch (err) {
      setError(err.response?.data.error || 'Add failed');
    }
  };

  return (
    <Container className="card-transparent p-4 text-center">
      <Header />
      <Navbar setPage={setPage} />

      <div className="mb-5">
        <h2 className="fw-bold">Inventory Management</h2>
        <p className="text-muted">
          Manage stock items and view current inventory status.
        </p>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}

      {/* Form Card */}
      <Row className="mb-4">
        <Col md={12}>
          <Card
            className="shadow-sm border-0"
            style={{
              background: 'rgba(255, 255, 255, 0.85)',
              transition: 'transform .2s, box-shadow .2s'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.12)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '';
            }}
          >
            <Card.Body>
              <h5 className="mb-3 fw-semibold">Add Inventory Item</h5>
              <Form className="row g-3 text-start">
                {Object.keys(form).map(key => (
                  <Form.Group key={key} className="col-md-4">
                    <Form.Label className="text-capitalize">
                      {key.replace(/([A-Z])/g, ' $1')}
                    </Form.Label>
                    <Form.Control
                      name={key}
                      type={
                        key === 'expiryDate'
                          ? 'date'
                          : ['quantity', 'currentPrice', 'supplierLeadTime', 'reorderPoint', 'orderFulfillmentTime'].includes(key)
                          ? 'number'
                          : 'text'
                      }
                      placeholder={`Enter ${key}`}
                      value={form[key]}
                      onChange={handleChange}
                    />
                  </Form.Group>
                ))}
                <div className="col-md-12 text-end">
                  <Button onClick={handleAdd}>Add Item</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Summary Card */}
      <Row className="mb-3 justify-content-center">
        <Col md={4}>
          <Card className="text-center shadow-sm border-0" style={{ background: 'rgba(255, 255, 255, 0.85)' }}>
            <Card.Body>
              <h6 className="text-muted">Total Inventory Items</h6>
              <h3 className="fw-bold text-primary">{items.length}</h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Inventory Table */}
      <Row>
        <Col md={12}>
          <Card className="shadow-sm border-0" style={{ background: 'rgba(255, 255, 255, 0.85)' }}>
            <Card.Body>
              <h5 className="mb-3 fw-semibold">Current Inventory Table</h5>
              <Table striped bordered hover responsive>
                <thead className="table-light">
                  <tr>
                    <th>Product ID</th>
                    <th>Store ID</th>
                    <th>Stock Levels</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map(item => (
                    <tr key={`${item.productId}-${item.storeId}`}>
                      <td>{item.productId}</td>
                      <td>{item.storeId}</td>
                      <td>{item.stockLevels || item.quantity}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
